import api from './api';

const incomeService = {
  list: async (month?: number, year?: number) => {
    const params: Record<string, any> = {};
    if (month) params.month = month;
    if (year) params.year = year;
    const res = await api.get('/incomes', { params });
    return res.data;
  },

  get: async (id: string) => {
    const res = await api.get(`/incomes/${id}`);
    return res.data;
  },

  create: async (payload: any) => {
    const res = await api.post('/incomes', payload);
    return res.data;
  },

  update: async (id: string, payload: any) => {
    const res = await api.put(`/incomes/${id}`, payload);
    return res.data;
  },

  remove: async (id: string) => {
    const res = await api.delete(`/incomes/${id}`);
    return res.data;
  },
};

export default incomeService;
